import { call, put, takeLatest, cancelled } from "redux-saga/effects";
import { actions } from "./slice";
import * as API from "../../../../services/apis";

function* handleFetchDetailed(action) {
  try {
    const { filtersString, pagination, filters } = action.payload;
    const response = yield call(API.fetchParameterAnalyticsDetailed, {
      filtersString,
      pagination,
      filters
    });
    const responseData = response?.data;
    const rawData = responseData?.data || responseData || {};
    
    yield put(actions.fetchDetailedSuccess({ 
      data: rawData.parameters || [],
      pagination: rawData.pagination || {
        currentPage: 1,
        totalPages: 1,
        totalCount: 0,
        limit: 10,
        hasNextPage: false,
        hasPrevPage: false
      },
      filters: rawData.filters || {}
    }));
    
  } catch (error) {
    if (yield cancelled()) {
      return;
    }
    yield put(actions.fetchDetailedFailure(error.message || "Failed to load parameter analytics data"));
  }
}

export function* parameterAnalyticsDetailedSaga() {
  yield takeLatest(actions.fetchDetailed.type, handleFetchDetailed);
}